import * as z from 'zod/mini';

export const cardPaymentSessionSchema = z.object({
  captureContext: z.string().check(z.minLength(1)),
  // Loaded as a <script>, so only accept https URLs.
  clientLibrary: z.url({ protocol: /^https$/ }),
  clientLibraryIntegrity: z.string().check(z.minLength(1)),
});

export type CardPaymentSession = z.infer<typeof cardPaymentSessionSchema>;
